import { Component } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { MessageService } from 'primeng/api';
import { ParameterService } from 'src/app/shared/service/params/param';
import { ActionServiceService } from '../../actions/action/action.component';
import { ObjectifSpecifique } from 'src/app/shared/models/objectif_specifique';
import { Constant } from 'src/app/shared/service/utils/contant';
import { LocalStorageService } from 'src/app/shared/service/storage/localstorage.service';
import { FecthDataService } from 'src/app/shared/service/fetchservice/fetchservice';

@Component({
  selector: 'app-edit-objectif-specifique',
  standalone: false,
  templateUrl: './edit-objectif-specifique.component.html',
  styleUrl: './edit-objectif-specifique.component.scss'
})


export class EditObjectifSpecifiqueComponent {
  constructor(
    private modalService: NgbModal,
    private paramService: ParameterService,
    private messageService: MessageService,
    private fetchService: FecthDataService,
    private ngxService: NgxUiLoaderService,
    private localStorage: LocalStorageService,
  ) {}

  item: ObjectifSpecifique = new ObjectifSpecifique();
  programmeData: any = [];
  agenceData: any = [];
  resultatItems: any = [];
  items: any = {};

  ngOnInit() {
    this.items = this.localStorage.getObjectif();
    this.item = { ...this.items };
    this.fetchDataPrograme();
  }

  close() {
    this.modalService.dismissAll();
  }

  editObejectif() {
    this.ngxService.start();
    this.item.programme_id = this.item.programme_id.id;
    this.paramService.editObjectif(this.item, this.items.reference).subscribe(
      (response: any) => {
        this.modalService.dismissAll();
        this.messageService.add({
          severity: 'success',
          summary: Constant.suiviTitle,
          detail: response.message || 'Mise à jour effectuée avec succès',
        });
        this.fetchService.notifySeriviceCreated();
        this.ngxService.stop();
      },
      (error: any) => {
        console.log("error",error);
        
        const errorMessage = error?.error?.message
            || error?.error?.error
            || error?.message
            || 'Une erreur est survenue';

        this.messageService.add({
          severity: 'error',
          summary: Constant.suiviTitle,
          detail: errorMessage,
        });
        this.fetchService.notifySeriviceCreated();
        this.ngxService.stop();
      }
    );
  }

  fetchDataPrograme() {
    this.paramService.fetchDataPrograme().subscribe(
      (response: any) => {
        this.programmeData = response.data;

        //  this.items.programme est un OBJET donc on compare avec .id
        this.item.programme_id = this.programmeData.find(
          (p: any) => p.id === this.items?.programme?.id
        );
      },
      (error) => {
        console.error('Erreur fetchDataPrograme', error);
      }
    );
  }

  onSelectProgramme() {
    this.item.code = this.item.programme_id.code + '.';
  }
}
